<template>
  <div class="v3-widget v3-panel v3-panel-pad" v-testid="testid">
    <div class="v3-panel-head" style="padding: 0 0 14px">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="steps.length" class="sub">Step {{ Math.min(cur + 1, steps.length) }} of {{ steps.length }}</span>
    </div>
    <div class="v3-jstepper" role="list">
      <div
        v-for="(s, i) in steps"
        :key="i"
        class="v3-spr-step"
        :class="'is-' + (i < cur ? 'done' : i === cur ? 'current' : 'todo')"
        role="listitem"
        v-testid="testid + '-row-' + s"
      >
        <span class="v3-spr-dot"><span v-if="i < cur" class="ms">check</span><template v-else>{{ i + 1 }}</template></span>
        <span class="v3-spr-lbl">{{ s }}</span>
        <span v-if="i < steps.length - 1" class="v3-spr-bar"></span>
      </div>
    </div>
  </div>
</template>

<script>
// New-portal (v3) Stepper — the evaluation-journey progress rail (prototype
// V3Stepper): horizontal discrete steps (done / current / todo). Pure
// presentation. Sibling: rm-portal-beta StepperWidget.vue.
const DEFAULT_STEPS = ["Upload JD", "Method", "Factor scoring", "Review", "Calibrate", "Accept"];
export default {
  name: "cLandingV3Stepper",
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3Stepper";
    },
    title() {
      return this.definition.title || "Evaluation progress";
    },
    steps() {
      const s = this.definition.steps;
      return Array.isArray(s) && s.length ? s : DEFAULT_STEPS;
    },
    cur() {
      const c = Number(this.definition.current);
      const n = this.steps.length - 1;
      return Math.max(0, Math.min(isNaN(c) ? 2 : c, n));
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
